// extracted by mini-css-extract-plugin
export var chevronIcon = "_6o-2";
export var teamName = "_6o-1";
export var teamSwitcherButton = "_6o-0";